import template from './building-address.jade';

export default angular
    .module('cian.addForm.buildingAddress', [])
    .directive('cianAfAddressBuildingAddress', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['$scope', 'deviceService', function ($scope, deviceService) {
            this.isMobile = deviceService.isMobile;
            $scope.$on('addform.clear', () => {
                this.ad.geo.buildingAddress = '';
            });
        }],
        controllerAs: 'buildingAddress',
        template,
    }))
    .name;
